import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import GeneralUtils from '../../../utils/GeneralUtils';

export const bikeRoutesServiceApi = createApi({
  reducerPath: 'bikeRoutesServiceApi',

  baseQuery: fetchBaseQuery({
    baseUrl: GeneralUtils.getEnvironment(window.location.origin),
    prepareHeaders: (headers, { getState }) => {
      const token = (getState()).authSlice.accountInformation.token;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    }
  }),

  endpoints: (builder) => ({

    getBikeRoutes: builder.mutation({
      query: ({ locale }) => ({
        url: `/poi/multipoint?locale=${locale}&categoryId=24`,
        method: 'GET',
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          console.error("Error fetching bike routes", err);
        }
      },
    }),

  }),
});

export const { useGetBikeRoutesMutation } = bikeRoutesServiceApi;